// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"SearchInput_searchInput__TwBU9","input":"SearchInput_input__8Ne_F"};